<template>
  <div class="special-message-wrap">
    <!--专题卡片-->
    <div class="special-card">
      <div class="special-img">
        <img :src="singleTopicInfo.topic_cover" alt />
      </div>
      <div class="special-content">
        <div class="special-content-t">
          <div class="special-content-t-l">
            <h3 class="little-title">{{singleTopicInfo.topic_name}}</h3>
            <div class="desc">{{singleTopicInfo.course_introduction}}</div>
          </div>
          <div class="special-content-t-r">
            <el-button
              type="text"
              size="small"
              @click="toLink($router,`/course/specialedit/${$route.params.id}`,true)"
            >编辑</el-button>
            <el-button
              v-if="singleTopicInfo.state==2||singleTopicInfo.state==1"
              type="text"
              size="mini"
              @click="downline(topicOffline(),{topic_id:$route.params.id},topicSingleinfo)"
            >下架</el-button>
            <el-button
              v-if="singleTopicInfo.state==3"
              type="text"
              size="mini"
              @click="online(topicOnline(),{topic_id:$route.params.id},topicSingleinfo)"
            >上架</el-button>
            <el-button type="text" size="small" @click="openShare($route.params.id,2)">分享</el-button>
          </div>
        </div>
        <div class="special-content-b flex-between gray">
          <span v-show="singleTopicInfo.topic_sell_mode==1">付费</span>
          <span v-show="singleTopicInfo.topic_sell_mode==2">免费</span>
          <span>更新至{{singleTopicInfo.update_num}}期（更新中）</span>
        </div>
      </div>
    </div>
    <!--课程搜索-->
    <div class="flex-y-center flex-between course-wrap">
      <el-button type="primary" round @click="addCourseCon()">添加关联课程</el-button>
      <div class="search-wrap">
        <div class="search-item">
          <el-select v-model="search.status" placeholder="请选择状态" @change="statusChange">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="iblock search-item">
          <el-input placeholder="搜索专题" v-model="search.keywords">
            <el-button slot="append" icon="el-icon-search" @click="searchCourse()"></el-button>
          </el-input>
        </div>
      </div>
    </div>

    <!--课程列表-->
    <div
      class="course-list-wrap"
      v-if="courseList.list&&courseList.list.length>0"
      v-loading="tableLoading"
    >
      <h3 class="little-title">专题内课程（{{courseList.count}}）</h3>
      <el-table class="course-table" :data="courseList.list" stripe>
        <el-table-column prop="course_name" label="课程名称"></el-table-column>
        <el-table-column prop="course_mode" label="直播类型">
          <template slot-scope="scope">
            <span v-show="scope.row.course_mode==1">语音直播</span>
            <span v-show="scope.row.course_mode==2">语音录播</span>
            <span v-show="scope.row.course_mode==3">视频直播</span>
            <span v-show="scope.row.course_mode==4">视频录播</span>
          </template>
        </el-table-column>
        <el-table-column prop="subscribe_num" label="访问数据"></el-table-column>
        <el-table-column prop="course_sell_price" label="打赏金额"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-show="scope.row.state==-1">删除</span>
            <span v-show="scope.row.state==1">定时上架</span>
            <span v-show="scope.row.state==2">已上架</span>
            <span v-show="scope.row.state==3">下架/未上架</span>
          </template>
        </el-table-column>
        <el-table-column prop="published_at" label="上架时间"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="courseEdit(scope.row)"
            >编辑</el-button>
            <el-button type="text" size="small" @click="openShare(scope.row.course_id,1)">分享</el-button>
            <el-button type="text" size="small" @click="delCourse(scope.row.course_id)">删除关联</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="tc mt20">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="Number(search.page)"
          :page-size="Number(search.size)"
          layout="total, prev, pager, next"
          :total="Number(courseList.count)"
        ></el-pagination>
      </div>
    </div>
    <!--  分享 -->
    <share-dialog :shareVisible.sync="shareVisible" :share_info="share_info"></share-dialog>
    <!-- 添加关联课程 -->
    <add-course-dialog
      :addCourseVisible.sync="addCourseVisible"
      @submitData="submitData"
      :isBtnShow="false"
    ></add-course-dialog>
  </div>
</template>

<script>
import course_mixins from "../play-template/course-mixins";

import AddCourseDialog from "../play-template/add-course-dialog.vue";

import {
  _topicSingleinfo, //获取单条专辑的信息
  _topicOnline, //专题上架
  _topicOffline, //专题下架
  _topicAddLinks //专题添加课程
} from "@/api/topic";

import { _getAllCourseList, _delSpeContact } from "@/api/course";
import qs from "qs";

export default {
  mixins: [course_mixins],
  created() {
    // console.log(this.$route.params.id);
    this.topicSingleinfo();
    this.getAllCourseList();
  },
  data() {
    return {
      addCourseVisible: false, //添加课程的弹窗
      tableLoading: false,
      search: {
        keywords: "",
        status: "0",
        page: 1,
        size: 10
      },
      singleTopicInfo: {},
      courseList: [],
      options: [
        {
          label: "全部状态",
          value: "0"
        },
        {
          label: "待上架",
          value: "1"
        },
        {
          label: "已上架",
          value: "2"
        },
        {
          label: "已下架",
          value: "3"
        }
      ]
    };
  },
  methods: {
    statusChange(val) {
      this.getAllCourseList();
    },
    //添加关联课程信息
    addCourseCon() {
      this.addCourseVisible = true;
    },
    //添加后的数据
    submitData(val1, val2) {
      if (val1.length > 0) {
        this.topicAddLinks(val1,this.$route.params.id);
      }
    },
    // 搜索课程
    searchCourse() {
      this.getAllCourseList();
    },
    //翻页
    handleCurrentChange(val) {
      this.search.page = val;
      this.topicSingleinfo();
    },
    // 上架
    topicOnline() {
      return _topicOnline;
    },
    //下架
    topicOffline() {
      return _topicOffline;
    },
    //编辑
    courseEdit(course){
      //1直播
      //2音频 
      if(course.course_mode==1){
        this.toLink(this.$router,`/course/live-edit/${course.course_id}`,true);
      }else if(course.course_mode==2){
        this.toLink(this.$router,`/course/audio-edit/${course.course_id}`,true);
      }
    },
    //获取专题信息
    topicSingleinfo() {
      _topicSingleinfo({
        params: {
          topic_id: this.$route.params.id,
          get_update_num:1
        }
      }).then(res => {
        if (res.resultCode == 1) {
          //添加一个单选功能属性来控制
          this.singleTopicInfo = res.result;
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
    //获取专题内的课程
    getAllCourseList() {
      this.tableLoading = true;
      _getAllCourseList({
        params: {
          page: this.search.page,
          size: this.search.size,
          keywords: this.search.keywords,
          state: this.search.status,
          topic_id: this.$route.params.id
        }
      }).then(res => {
        // console.log(res);
        this.tableLoading = false;
        if (res.resultCode == 1) {
          //添加一个单选功能属性来控制
          this.courseList = res.result;
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
    //删除关联的数据
    delCourse(id) {
      _delSpeContact({
        params: {
          course_id: id
        }
      }).then(res => {
        if (res.resultCode == 1) {
          //添加一个单选功能属性来控制
          this.$message.success(res.errorMsg);
          this.getAllCourseList();
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
    //专题添加课程
    topicAddLinks(course_ids, topic_id) {
      _topicAddLinks({
        data: qs.stringify({
          course_ids: course_ids,
          topic_id: topic_id
        })
      }).then(res => {
        if (res.resultCode == 1) {
          this.$message.success(res.errorMsg);
          this.getAllCourseList();
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    }
  },
  components: {
    AddCourseDialog
  }
};
</script>

<style lang="less" scoped>
.special-card {
  padding: 10px;
  background-color: @table-bg;
  border-radius: 10px;
  display: flex;
  align-items: center;
  overflow: hidden;
  .special-img {
    width: 160px;
    height: 90px;
    overflow: hidden;
    background-color: #ffffff;
    img {
      height: 100%;
      width: 100%;
    }
  }
  .special-content {
    flex: 1;
    margin-left: 10px;
    position: relative;
  }
  .special-content-t {
    display: flex;
    
  }
  .special-content-t-l {
    flex: 1;
    .desc {
      margin: 10px 0;
    }
  }
  // .special-content-b {
    // position: absolute;
    // bottom: 0;
    // left: 0;
    // right: 0;
  // }
}

.course-wrap {
  margin-top: 20px;
}

.search-item {
  display: inline-block;
  & + .search-item {
    margin-left: 10px;
  }
}

.course-table,
.course-list-wrap {
  margin-top: 20px;
}

.pagination-wrap {
  margin-top: 20px;
  text-align: center;
}

.dropdown-btn {
  margin-left: 10px;
}
</style>
